export const SELF_IMPROVEMENT = "selfImprovement";
export const ENTREPRENEURSHIP = "entrepreneurship";
export const EDUCATION = "education";
export const ALL_RESOURCES = "resources"



// WEBPACK FOOTER //
// ./src/constants/resourceTypes.js